import { createFileRoute } from "@tanstack/react-router";

import OpportunitiesApply from "@/features/opportunities/OpportunitiesApply";
import SideNavLayout from "@/layouts/SideNavLayout";
import { OpportunitiesMenu } from "@/layouts/SubSideNavMenus";

export const Route = createFileRoute("/_auth/opportunities/apply/$opportunityId")({
  component: () => (
    <SideNavLayout menu={<OpportunitiesMenu />}>
      <OpportunitiesApply key="update" />
    </SideNavLayout>
  ),
});
